import { Box, Card, CardContent, Grid, IconButton, Paper, Typography } from '@mui/material'
import React, { useContext } from 'react'
import { useForm } from 'react-hook-form'
import { StepperDataContext } from './AddEditCustomer'
import AddressForm from './AddressForm'
import AddAddress from './address/AddAddress'
import { CustomerService } from '../Service'
import { Delete } from '@mui/icons-material'
import Swal from 'sweetalert2'

const AddressDetails = () => {
  const {otrDetails,setOtrDetails,profileData,setProfileData,addressData,setAddressData,customerData,tabValue,setTabValue,fetchCustomerDetailById,setCustomerData} = useContext(StepperDataContext)
  
  const fetchAllAddress = async ()=>{        
        try{
            const response = await CustomerService.fetchCustomerAddresses(customerData.id);
            console.log(response);
            if(response.success == '1'){
                setCustomerData(pre=>{
                    return {...pre,customerAllAddress:response.data}
                });
            }
        }catch(error){
            console.log(error);
        }
    }
    const deleteAddress = async (id)=>{
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      })
      if (result.isConfirmed) {
        Swal.fire({
          title:'Please Wait...',
          text: 'Please wait while we delete your address',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          }
        })
        try{
            const response = await CustomerService.deleteCustomerAddress(id);
            console.log(response);
            if(response.success == '1'){
              Swal.fire({
                icon: 'success',
                title: 'Success!',
                text: response.message || 'Address Deleted Successfully',
                timer: 1000
              });
                fetchAllAddress();
            }
        }catch(error){
            console.log(error);
        }
      }
    }
  return (
    <Box >
        <Grid container spacing={1} sx={{ }}>
          <Grid item xs={12} sm={6} >
            <Card>
              <Box sx={{ p: '.5% 1%', border: '2px solid lightGray', bgcolor: 'lightGray' }}>
                <Typography sx={{ fontWeight: '600', fontSize: '0.85rem' }}>Add New Address</Typography>
              </Box>
              <AddAddress customer={customerData} fetchAllAddress={fetchAllAddress}s/>
            </Card>
            
          </Grid>
          <Grid item xs={12} sm={6} >
            <Card>
              <Box sx={{ p: '.5% 1%', border: '2px solid lightGray', bgcolor: 'lightGray' }}>
              <Typography sx={{ fontWeight: '600', fontSize: '0.85rem' }}>Saved Addresses</Typography>
            </Box>
          {customerData?.customerAllAddress && customerData.customerAllAddress.length > 0 ?
              customerData.customerAllAddress.map((address, index) => (
                  
                      <Paper sx={{ p: '2%', mb: '.5%' }} key={index} >
                          <Box sx={{ display: 'flex', alignItems: 'center', mb: '1%', gap: '2%' }}>
                              <Typography fontWeight={'500'} sx={{ fontSize: 'small', color: '#778899',lineHeight:1 }}>{address.fullName} {address.mobileNumber ? `(${address.mobileNumber})`:''}</Typography>
                              <Typography variant='caption' sx={{ fontSize: 'xx-small', bgcolor: '#d2d2d2', color: '#696969', textTransform: "uppercase", p: '.5% 1%', lineHeight: 1.3, borderRadius: '.15rem' }}>
                                {address.addressType == '1' && 'Home'}
                                {address.addressType == '2' && 'Office'}
                                {address.addressType == '3' && 'Other'}
                                {address.addressType == '4' && 'Family & Friend'}
                              </Typography>                              
                              <IconButton size='small' onClick={()=>deleteAddress(address.id)}><Delete color='error'/></IconButton>
                          </Box>
                          <Typography fontWeight={'500'} sx={{ fontSize: 'small', textTransform: 'capitalize' }}>{address.address}</Typography>
                      </Paper>
                  
              ))
              :
              <Grid item xs={12} sx={{ p: '2%', display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '10rem' }}>
                  <Typography fontWeight={'medium'} sx={{ fontSize: 'small', textTransform: 'capitalize' }}>No Address found</Typography>
              </Grid>
          }
            </Card>
          </Grid>
        </Grid>    
    </Box>
  )
}

export default AddressDetails
